export default function InsuranceEstimatesSection() {
  const cards = [
    {
      icon: "ri-file-text-line",
      title: "Line Item Confusion",
      desc: "Insurance estimates use industry codes, abbreviations, and jargon that most homeowners can't decipher. Hidden within those lines are items you're entitled to — but only if you know to ask for them.",
    },
    {
      icon: "ri-calculator-line",
      title: "The Price Gap Myth",
      desc: "Carrier estimates often look lower than contractor bids — and homeowners assume they have to make up the difference out of pocket. In reality, the gap is almost always covered by recoverable depreciation and supplement items.",
    },
    {
      icon: "ri-file-search-line",
      title: "Missing Scope Items",
      desc: "Adjusters work fast and sometimes miss items: code upgrades, drip edge, ice & water shield, ventilation, or damaged decking. These are legitimate claim items that can be supplemented — but only if someone catches them.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Supplement Negotiations",
      desc: "Quality roofing often requires additional materials discovered during tear-off. We document everything, photograph every detail, and handle all supplement negotiations with your carrier at no extra cost to you.",
    },
  ];

  return (
    <section id="estimates" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#1a1a2e]/8 text-[#1a1a2e] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            <i className="ri-eye-line"></i>
            Understanding Insurance Estimates
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#1a1a2e] leading-tight mb-4">
            Can You Read This? Most Homeowners Can&apos;t — <br className="hidden md:block" />
            <span className="text-[#f97316]">And It Costs Them Thousands</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            Insurance estimates are written for adjusters, not homeowners. Without knowing how to read them, you&apos;re flying blind — and contractors who don&apos;t explain them are counting on that.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {cards.map((card) => (
            <div
              key={card.title}
              className="bg-[#f8f5f0] rounded-xl p-6 border border-gray-100 hover:border-[#f97316]/30 transition-colors duration-200"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#f97316]/15 rounded-lg mb-4">
                <i className={`${card.icon} text-[#f97316] text-2xl`}></i>
              </div>
              <h3 className="text-[#1a1a2e] font-bold text-base mb-3">{card.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{card.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className="bg-[#1a1a2e] rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1">
            <h3 className="text-white font-black text-2xl md:text-3xl mb-3">
              We Translate Your Estimate — Line by Line
            </h3>
            <p className="text-white/65 text-base leading-relaxed">
              RidgeCap GC sits down with every homeowner and walks through their insurance estimate in plain English. We identify every recoverable item, flag missing scope, and make sure you understand exactly what you&apos;re entitled to before a single shingle is touched.
            </p>
          </div>
          <div className="flex-shrink-0">
            <a
              href="#cta"
              className="inline-flex items-center gap-2 bg-[#f97316] hover:bg-[#ea6c0a] text-white font-bold px-8 py-4 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
            >
              Get a Free Estimate Review
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
